import { CollapsibleSection } from '../components/CollapsibleSection';

export default CollapsibleSection;
